import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isOptionSelected' })
export class IsOptionSelected<T> implements PipeTransform {
  transform(
    selections: T[],
    option: T
  ): boolean {
    return selections.includes(option);
  }
}
